// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDJTZ2YcJQy9MZvyCqfvfR0Vhec83BMntw",
  authDomain: "mobipoly-game.firebaseapp.com",
  projectId: "mobipoly-game",
  storageBucket: "mobipoly-game.firebasestorage.app",
  messagingSenderId: "968512238586",
  appId: "1:968512238586:web:2f97ce13a5e6872b7e2a43",
  measurementId: "G-QC1HSDHHZ8",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
